import { Injectable } from '@angular/core';
import { WindowService } from 'shared/services/window/window.service';
import { WindowOpenProperties } from 'shared/services/window/window-open-properties.interface';

@Injectable({
  providedIn: 'root'
})
export class PopupWindowService {
  constructor(
    private _windowService: WindowService
  ) {
  }

  preparePopupFor(windowTarget: string): void {
    this._focusOrOpenPopupWindow('', windowTarget);
  }

  navigateAndFocusOrOpenPopupWindow(url: string, windowTarget: string): void {
    this._focusOrOpenPopupWindow(url, windowTarget);
  }

  focusOrOpenPopupWindow(url: string, windowTarget: string): void {
    const popupWindow = this._focusOrOpenPopupWindow('', windowTarget);

    try {
      if (popupWindow.location?.href === url) {
        return;
      }
    } catch (error) {
      // We expect DOMException due to accessing a cross-origin frame.
      // Assume vendor app is loaded in this case from vendor's origin.
      return;
    }

    popupWindow.location.href = url;
  }

  private _focusOrOpenPopupWindow(url: string, windowTarget: string): Window {
    const windowOpenProperties = this._getWindowOpenProperties();
    const popupWindow = this._windowService.open(url, windowTarget, windowOpenProperties);
    popupWindow.focus();
    return popupWindow;
  }

  private _getWindowOpenProperties(): WindowOpenProperties {
    const { screen } = this._windowService.getWindow();

    const width = screen.width / 2;
    const height = screen.height / 2;
    const left = (screen.width - width) / 2;
    const top = (screen.height - height) / 2;

    return {
      toolbar: false,
      scrollbars: true,
      resizable: true,
      width,
      height,
      top,
      left
    };
  }
}
